import { render, staticRenderFns } from "./AwardExchanges.vue?vue&type=template&id=2445bc06"
import script from "./AwardExchanges.vue?vue&type=script&lang=js"
export * from "./AwardExchanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports